export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/share/icon-sns-line-cacf87678599df1088cc6ee6fe82ea42.svg";